export default class MockApi {
	static get({ data, timeout = 0 }) {
		return new Promise((resolve) => {
			setTimeout(() => resolve(data), timeout);
		});
	}
}
